// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"Icon_iconButton__17pR1","inlineIcon":"Icon_inlineIcon__2R8V3","large":"Icon_large__1zvFR","disabled":"Icon_disabled__3Eedd"};